// extracted by mini-css-extract-plugin
export default {"container":"PropertyPageTaxData_container__s5-uw","title":"PropertyPageTaxData_title__Ciwps","informationItem":"PropertyPageTaxData_informationItem__nfXfW"};